var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoins = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M6.008 7.205a6.57 6.57 0 0 0 .034 1.038 4.5 4.5 0 1 0 5.717 5.715 6.424 6.424 0 0 0 1.036.035 5.5 5.5 0 1 1-6.788-6.789Zm.52 2.865c.14.326.306.637.494.93H7c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L7 12h.81a6.523 6.523 0 0 0 1.669 1.257 1.49 1.49 0 0 1-1.332 1.736L8 15v1H7v-1H6v-1h1.998a.491.491 0 0 0 .502-.5.478.478 0 0 0-.405-.492L8 13H7a1.47 1.47 0 0 1-1.5-1.5c0-.687.42-1.24 1.029-1.43ZM12.5 2a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm.5 1v1h1v1h-2c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L12 7h1.003c.85.005 1.497.663 1.497 1.5a1.49 1.49 0 0 1-1.353 1.493L13 10v1h-1v-1h-1V9h1.998a.491.491 0 0 0 .502-.5.478.478 0 0 0-.405-.492L13 8h-1a1.47 1.47 0 0 1-1.5-1.5c0-.803.574-1.423 1.352-1.493L12 5V4h1Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoins);
export default ForwardRef;